import { ResponseGetOrders } from '@vindr/services/apis/order.api';
import { Modal, Typography } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';
import { useTranslation } from 'react-i18next';
import EditOrderForm from './EditOrderForm';
const { Title } = Typography;

const EditOrder = ({
  orderData,
  isEditing,
  onFinish,
  message,
}: {
  orderData: ResponseGetOrders['data'][number];
  isEditing: boolean;
  onFinish: () => void;
  message: MessageInstance;
}) => {
  const { t } = useTranslation('Vindoc');

  return (
    <Modal
      className="vindr-modal add-order max-w-screen w-[900px]"
      title={false}
      open={isEditing}
      maskClosable={false}
      destroyOnClose
      zIndex={1001}
      onCancel={onFinish}
      footer={null}
    >
      <Title level={3} className="mb-6">
        {t('Edit Order')}
      </Title>
      <EditOrderForm orderData={orderData} onFinish={onFinish} message={message} />
    </Modal>
  );
};

export default EditOrder;
